@for (set of sets; track $index; let setIndex = $index) {
  @if (setIndex < displayedRows) {
    <div [class]="setWrapperClass">
      @for (item of set.items; track $index; let index = $index) {
        <div
          [@fadeIn]
          [style.flexBasis.%]="item.flexBasis"
          [class]="itemWrapperClass"
          (click)="itemClicked.emit(item.galleryItem)"
        >
          <ng-container *ngTemplateOutlet="cardTpl; context: { media: item.galleryItem.media }"></ng-container>
        </div>
      }
    </div>
  }
}
@if (sets.length > initiallyVisibleRows) {
  <div class="gallery-btn-wrapper">
    @if (sets.length > displayedRows) {
      <div class="btn btn-secondary" (click)="displayedRows = displayedRows + moreRows">
        {{ 'MORE' | translate }}
      </div>
      <div class="btn btn-secondary" (click)="displayedRows = sets.length">
        {{ 'SHOW_ALL' | translate }}
      </div>
    }
    @if (displayedRows >= sets.length) {
      <div class="btn btn-secondary" (click)="displayedRows = initiallyVisibleRows">
        {{ 'SHOW_LESS' | translate }}
      </div>
    }
  </div>
}

<ng-template #cardTpl let-media="media">
  <mb-media
    [media]="media"
    [class.media-image]="media.type === 'image'"
    [hoverplay]="true"
    [hideTitles]="true"
  ></mb-media>
  <div class="card-footer">
    @if (buttonItems.length) {
      <mb-action-container
        [buttonItems]="buttonItems"
        [resource]="media"
        (actionClick)="itemActionClicked.emit({ action: $event, media: media })"
      ></mb-action-container>
    }
  </div>
</ng-template>
